
import {
	AfterViewInit,
	Directive,
	ElementRef,
	HostListener,
	Input,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { formatPhoneNumber } from '@app/utils/phone-number-formatter';

@Directive({
	standalone: false,
	selector: '[qeInputMask]',
})
export class InputMaskDirective implements AfterViewInit {
	@Input() qeInputMask!: string;
	private inputEl!: HTMLInputElement;
	private readonly acceptedButtons = ['Delete', 'Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];

	constructor(private readonly el: ElementRef, private readonly control: NgControl) { }

	@HostListener('keydown', ['$event'])
	_handleKeydown(ev: KeyboardEvent): void {
		const currentInputValue = this.inputEl?.value.replace(/\D/g, '') ?? '';
		// eslint-disable-next-line @typescript-eslint/no-magic-numbers
		if (this.qeInputMask === 'phone' && currentInputValue.length === 10 && !this.acceptedButtons.includes(ev.code)) {
			ev.preventDefault();
			ev.stopImmediatePropagation();
		}
	}

	@HostListener('input')
	_handleInput(): void {
		setTimeout(() => {
			this.handleInput();
		}, 0);
	}

	@HostListener('change')
	_handleChange(): void {
		setTimeout(() => {
			this.handleInput();
		}, 0);
	}


	ngAfterViewInit(): void {
		this.inputEl = this.el.nativeElement;
		this.handleInput();
	}

	private handleInput(): void {
		switch (this.qeInputMask) {
			case 'phone':
				this.maskPhoneNumber();
				break;
			case 'expiry':
				this.maskExpiryDate();
				break;
			case 'date':
				this.maskDateOfBirth();
				break;
			default:
				return;
		}
	}

	private maskPhoneNumber(): void {
		// eagerly setting the value retriggers logic tied to forms where inputs with this directive are used
		// only set the value when the input value does not matdch the prospective formatted value
		if (this.inputEl.value !== formatPhoneNumber(this.inputEl.value)) {
			if(this.control && this.control.control){
				this.control.control.setValue(formatPhoneNumber(this.inputEl.value));
			} else {
				this.inputEl.value = formatPhoneNumber(this.inputEl.value);
			}
		}
	}

	private maskExpiryDate(): void {
		const expiryRegEx = /(\d{2})(\d{2})/;
		this.el.nativeElement.value = this.inputEl.value
			.replace(/(\D)/g, '')
			.replace(expiryRegEx, '$1/$2');
	}

	private maskDateOfBirth(): void {
		const expiryRegEx = /(\d{2})(\d{2})(\d{4})/;
		const formattedValue =
			this.inputEl.value
				.replace(/(\D)/g, '')
				.replace(expiryRegEx, '$1/$2/$3');

		this.el.nativeElement.value = formattedValue;
		this.control.control?.setValue(formattedValue);
	}
}
